// Read limits from environment variables
const PRO_REQUESTS_LIMIT = parseInt(import.meta.env.VITE_PRO_REQUESTS_LIMIT, 10) || 10;
const ADVANCED_REQUESTS_LIMIT = parseInt(import.meta.env.VITE_ADVANCED_REQUESTS_LIMIT, 10) || 100;

export const PRICING_PLANS = {
  pro: {
    id: 'pro',
    name: 'Pro',
    price: 10,
    requests: PRO_REQUESTS_LIMIT,
    period: 'month',
    priceId: import.meta.env.VITE_STRIPE_PRO_PRICE_ID,
  },
  advanced: {
    id: 'advanced',
    name: 'Advanced',
    price: 80,
    requests: ADVANCED_REQUESTS_LIMIT,
    period: 'month',
    priceId: import.meta.env.VITE_STRIPE_ADVANCED_PRICE_ID,
  },
};

/**
 * Create a Stripe checkout session
 */
export async function createCheckoutSession(priceId, userId, userEmail) {
  const response = await fetch('/.netlify/functions/create-checkout-session', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      priceId,
      userId,
      userEmail,
    }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || 'Failed to create checkout session');
  }

  const { url } = await response.json();
  window.location.href = url;
}

/**
 * Create a Stripe billing portal session for subscription management
 */
export async function createPortalSession(userId) {
  const response = await fetch('/.netlify/functions/create-portal-session', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ userId }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.message || 'Failed to create portal session');
  }

  const { url } = await response.json();
  window.location.href = url;
}
